(function () {
  'use strict';
  if (window.__scarlatCheckoutReady) return;
  window.__scarlatCheckoutReady = true;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var minimum = 80000, revision = 0, total = null, timer;
  var allowedForms = new WeakSet();
  var customer = null;
  async function readCustomer() {
    try { var response = await fetch(root+'apps/scarlat/customer-state',{credentials:'same-origin',cache:'no-store'}); customer = response.ok ? await response.json() : null; }
    catch (_) { customer = null; }
  }
  function reorderEligible() { return customer?.authenticated === true && customer?.recompra_eligible === true && customer?.recompra_checkout_enabled === true; }
  function benefitMessage() { var date = customer?.recompra_minimo_data; return date ? 'Sua recompra está liberada sem pedido mínimo até '+date.slice(8,10)+'/'+date.slice(5,7)+'.' : ''; }
  var scalaRoots = new WeakSet(), scalaTimer;
  function syncPixButtons() {
    document.querySelectorAll('scala-cart-button').forEach(function(host) {
      var shadow = host.shadowRoot;
      if (!shadow) return;
      if (!scalaRoots.has(shadow)) {
        scalaRoots.add(shadow);
        new MutationObserver(schedulePixButtons).observe(shadow, {childList:true,subtree:true});
      }
      shadow.querySelectorAll('button[data-trigger]').forEach(function(button) {
        var tier = button.dataset.trigger === '2' ? 10 : 5;
        var eligible = total !== null && total >= minimum && tier === (total >= 150000 ? 10 : 5);
        button.disabled = !eligible;
        button.style.setProperty('display', eligible ? 'flex' : 'none', 'important');
      });
    });
  }
  function schedulePixButtons() {
    clearTimeout(scalaTimer);
    scalaTimer = setTimeout(syncPixButtons, 20);
  }
  function rules(cart) {
    var subtotal = Number(cart.items_subtotal_price);
    if (!Number.isFinite(subtotal) || subtotal < 0) throw new Error('Subtotal indisponível');
    var pixPercent = subtotal >= 150000 ? 10 : subtotal >= minimum ? 5 : 0;
    return {subtotal:subtotal,remaining:reorderEligible()?0:Math.max(0,minimum-subtotal),eligible:subtotal>=minimum||reorderEligible(),pixPercent:pixPercent,pixSaving:Math.round(subtotal*pixPercent/100)};
  }
  window.ScarlatCheckoutRules = {evaluate:rules};
  function money(cents) { return new Intl.NumberFormat('pt-BR', {style:'currency',currency:'BRL'}).format(cents / 100); }
  function signature(cart) { return JSON.stringify([cart.total_price,(cart.items||[]).map(function(i){return [i.key,i.quantity,i.final_line_price,i.grams];})]); }
  function state(cart) {
    var calculation = rules(cart);
    total = calculation.subtotal;
    syncPixButtons();
    var remaining = calculation.remaining;
    document.querySelectorAll('[data-scarlat-drawer-pix-title]').forEach(function(node) {
      node.textContent = total >= 150000 ? 'Você chegou aos 10% OFF no PIX' : total < minimum ? '5% OFF no PIX a partir de R$ 800' : 'Seu pedido já tem 5% OFF no PIX';
    });
    document.querySelectorAll('[data-scarlat-drawer-pix-message]').forEach(function(node) {
      node.textContent = total < minimum ? 'Neste pedido, o PIX não tem desconto. Com mais ' + money(minimum-total) + ' em peças, você libera 5% OFF no PIX.' : total < 150000 ? 'Com mais ' + money(150000-total) + ' em peças, o desconto passa para 10% no PIX.' : 'Escolha o botão PIX para receber o desconto. Os descontos não se somam.';
    });
    document.querySelectorAll('[data-scarlat-drawer-pix-progress]').forEach(function(node) {node.value = Math.min(total,150000);});
    document.querySelectorAll('[data-scarlat-drawer-pix-estimate]').forEach(function(node) {
      node.textContent = total < minimum ? (reorderEligible() ? 'Recompra liberada sem mínimo. Desconto no PIX somente a partir de R$ 800 em peças.' : 'O pagamento é liberado a partir de R$ 800 em peças.') : 'Economia estimada no PIX: ' + money(calculation.pixSaving) + '. Confirmada no checkout.';
    });
    document.querySelectorAll('[data-scarlat-pix-saving]').forEach(function (node) { node.textContent = money(calculation.pixSaving); });
    document.querySelectorAll('[data-scarlat-pix-total]').forEach(function (node) { node.textContent = money(total-calculation.pixSaving); });
    document.documentElement.classList.toggle('scarlat-minimum-blocked', remaining > 0);
    document.querySelectorAll('[data-scarlat-minimum-message]').forEach(function (node) {
      node.textContent = reorderEligible() ? benefitMessage() : remaining ? 'Faltam ' + money(remaining) + ' em peças para finalizar seu pedido.' : 'Seu pedido já atingiu o valor mínimo.';
    });
    document.querySelectorAll('[data-scarlat-minimum-progress]').forEach(function (node) { node.value = Math.min(total, minimum); });
    document.querySelectorAll('[name="checkout"]').forEach(function (button) { button.disabled = remaining > 0 || !cart.item_count; });
    document.querySelectorAll('[data-scarlat-shipping-result]').forEach(function (node) {
      if (node.dataset.quotedSignature && node.dataset.quotedSignature !== signature(cart)) {
        node.replaceChildren(); node.textContent = 'Seu pedido mudou. Calcule o frete novamente.'; delete node.dataset.quotedSignature;
      }
    });
    return cart;
  }
  async function readCart() {
    var response = await fetch(root+'cart.js', {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('Carrinho indisponível');
    return response.json();
  }
  async function refresh() {
    var current = ++revision;
    try { await readCustomer(); var cart = await readCart(); if (current === revision) state(cart); }
    catch (_) { total = null; syncPixButtons(); document.querySelectorAll('[name="checkout"]').forEach(function (button) { button.disabled = true; }); }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 120); }
  function showMinimum() {
    var node = document.querySelector('[data-scarlat-minimum]');
    if (node) node.scrollIntoView({block:'center',behavior:'smooth'});
  }
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (allowedForms.has(form)) { allowedForms.delete(form); return; }
    var button = event.submitter;
    if (!button || button.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation(); button.disabled = true;
    try {
      state(await readCart());
      // Validation Function is the final authority; precheckout handles native authentication/consultora.
      allowedForms.add(form); button.disabled = false; form.requestSubmit(button);
    } catch (_) {
      var node = document.querySelector('[data-scarlat-minimum-message]');
      if (node) node.textContent = 'Não foi possível conferir o pedido. Atualize a página e tente novamente.';
    }
  }, true);
  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('[data-scarlat-shipping-form]');
    if (!form) return;
    event.preventDefault();
    var block = form.closest('.scarlat-shipping'), output = block.querySelector('[data-scarlat-shipping-result]');
    var button = form.querySelector('button'), values = new FormData(form), zip = String(values.get('zip') || '').replace(/\D/g,'');
    if (zip.length !== 8) { output.textContent = 'Informe um CEP com 8 números.'; return; }
    button.disabled = true; output.textContent = 'Consultando as opções de entrega…';
    try {
      var cart = await readCart();
      if (!cart.item_count) { output.textContent = 'Adicione peças ao carrinho para calcular o frete.'; return; }
      var quotedSignature = signature(cart);
      if (form.dataset.freightEndpoint) {
        var quoted = await fetch(form.dataset.freightEndpoint, {
          method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({cep:zip,items:cart.items.map(function(item){return {sku:item.sku,quantity:item.quantity};})}),
          signal:AbortSignal.timeout(30000)
        });
        var quote = await quoted.json();
        if (!quoted.ok || !quote.rates || !quote.rates.length) throw new Error('Não foi possível calcular este pedido. Confira o CEP ou fale com a Scarlat.');
        if (signature(await readCart()) !== quotedSignature) throw new Error('Seu pedido mudou durante a consulta. Calcule novamente.');
        output.replaceChildren();
        var contractList = document.createElement('ul');
        quote.rates.forEach(function(rate){
          var row=document.createElement('li');
          row.textContent=rate.service_name+' — '+money(Number(rate.total_price))+' — '+rate.description;
          contractList.appendChild(row);
        });
        output.appendChild(contractList); output.dataset.quotedSignature=quotedSignature;
        return;
      }
      var params = new URLSearchParams({'shipping_address[zip]':zip,'shipping_address[country]':'Brazil','shipping_address[province]':values.get('province')});
      var prepared = await fetch(root+'cart/prepare_shipping_rates.json?'+params,{method:'POST',credentials:'same-origin'});
      if (!prepared.ok) throw new Error('Confira o CEP e o estado informados.');
      var data = null;
      for (var i=0;i<8;i++) {
        var response = await fetch(root+'cart/async_shipping_rates.json?'+params,{credentials:'same-origin',cache:'no-store'});
        if (!response.ok) throw new Error('Não foi possível calcular agora. Tente novamente.');
        data = await response.json(); if (data !== null) break;
        await new Promise(function (resolve) { setTimeout(resolve,800); });
      }
      if (!data) throw new Error('A consulta está demorando. Tente novamente em instantes.');
      if (signature(await readCart()) !== quotedSignature) throw new Error('Seu pedido mudou durante a consulta. Calcule novamente.');
      output.replaceChildren();
      if (!data.shipping_rates || !data.shipping_rates.length) {
        output.textContent = 'Não encontramos uma opção de entrega para este pedido e CEP. Confira os dados ou fale com a Scarlat.'; return;
      }
      var list = document.createElement('ul');
      data.shipping_rates.forEach(function (rate) {
        var row = document.createElement('li'), price = Math.round(Number(rate.price)*100);
        row.textContent = (rate.presentment_name || rate.name) + ' — ' + money(price); list.appendChild(row);
      });
      output.appendChild(list); output.dataset.quotedSignature = quotedSignature;
    } catch (error) { output.textContent = error.message || 'Não foi possível calcular o frete agora.'; }
    finally { button.disabled = false; }
  });
  function init() {
    new MutationObserver(schedulePixButtons).observe(document.body, {childList:true,subtree:true});
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    document.addEventListener('cart:lines-update',schedule);
    document.addEventListener('shopify:section:load',schedule);
    document.addEventListener('visibilitychange',function () { if (!document.hidden) schedule(); });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
